import * as React from "react"

type Props = {
  height: number

}

type State = {
  scrollHeight: number
  open: boolean

}

export default class extends React.Component<Props, State> {
  containerRef: React.RefObject<HTMLDivElement>
  resizeTimer : number
  constructor(props: Props) {
    super(props)
    this.containerRef = React.createRef();
    this.state = {
      scrollHeight: null,
      open: false
    }

    this.onResize = this.onResize.bind(this)
  }

  componentDidMount() {
    this.maybeUpdateScrollheightFromRef();
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  componentDidUpdate() {
    this.maybeUpdateScrollheightFromRef();
  }

  private onResize() {
    if (this.resizeTimer) {
      window.clearTimeout(this.resizeTimer)
    }
    this.resizeTimer = window.setTimeout(() => this.maybeUpdateScrollheightFromRef(), 100)
  }

  private maybeUpdateScrollheightFromRef() {
    if (this.containerRef && this.containerRef.current.scrollHeight != this.state.scrollHeight) {
      this.setState({ scrollHeight: this.containerRef.current.scrollHeight })
    }
  }

  private shouldRenderUncollapsable() : boolean {
    return !this.state.scrollHeight || this.state.scrollHeight < this.props.height + 20
  }

  private toggle(e : React.MouseEvent<HTMLElement>) : void {
    e.preventDefault();
    this.setState({ open: !this.state.open })
  }

  render() {
    return this.shouldRenderUncollapsable() ? <div className="readmore-section readmore-expanded" ref={this.containerRef}>
      {this.props.children}
    </div> : this.state.open ? <>
      <div className="readmore-section readmore-expanded" ref={this.containerRef} style={{ height: this.state.scrollHeight }}>
        {this.props.children}
      </div>
      <a href="#" className="readmore-toggle" onClick={(e) => this.toggle(e)}>
        <span>-</span>{I18n.t('adverts.javascript.read_less')}
      </a>
    </> : <>
      <div className="readmore-section" ref={this.containerRef} style={{ height: this.props.height }}>
        {this.props.children}
      </div>
      <a href="#" className="readmore-toggle" onClick={(e) => this.toggle(e)}>
        <span>+</span>{I18n.t('adverts.javascript.read_more')}
      </a>
    </>
  }
}
